import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Layout, Menu } from "antd";
import { forEach } from "lodash";
import { inject, observer } from "mobx-react";
import InsurforceLogo from "../../assets/img/LogoScreen.png";

const menuItems = [
	{
		id: "quotes",
		href: "/quotes",
		title: "Quotes",
		auth: true,
	},
	{
		id: "policies",
		href: "/policies",
		title: "Policies",
		auth: true,
	},
	{
		id: "renewals",
		href: "/renewals",
		title: "Renewals",
		auth: true,
	},
	{
		id: "reports",
		href: "/reports",
		title: "Reports",
		auth: true,
	},
	{
		id: "admin",
		href: "/admin",
		title: "Admin",
		auth: true,
	},
	{
		id: "rates",
		href: "/rates/active",
		title: "Rates",
		auth: true,
	},
];

/**
 * Default layout.
 */
@inject("context")
@withRouter
@observer
class DefaultLayout extends Component {
	render() {
		const menuSelectedKeys = [];
		const path = this.props.location.pathname;
		const service = this.props.context.applicationService;
		const layoutContentProps = this.props.layoutContentProps;

		forEach(menuItems, (val) => {
			if (path.indexOf(val.href) === 0) {
				menuSelectedKeys.push(val.id);
			}
		});

		return (
			<Layout style={{ minHeight: "100%" }}>
				<Layout.Header style={{ display: "flex" }}>
					<div
						style={{ color: "white", fontSize: "2rem", marginRight: "auto" }}
					>
						<Link style={{ color: "white" }} to="/">
							<img
								style={{
									width: "auto",
									maxHeight: "120%",
									display: "block",
								}}
								src={InsurforceLogo}
								alt="Insurforce"
								title="Insurforce"
							/>
						</Link>
					</div>
					<Menu
						theme="dark"
						mode="horizontal"
						style={{ lineHeight: "64px" }}
						selectedKeys={menuSelectedKeys}
					>
						{menuItems.map((item) => {
							if (item.auth && !service.isAuthenticated) {
								return null;
							}

							return (
								<Menu.Item key={item.id}>
									<Link to={item.href}>{item.title}</Link>
								</Menu.Item>
							);
						})}
						{service.isAuthenticated && (
							<Menu.Item>
								<Button type="link" onClick={this.handleLogoutButtonClick}>
									Logout
								</Button>
							</Menu.Item>
						)}
					</Menu>
				</Layout.Header>
				<Layout.Content {...layoutContentProps}>
					{this.props.children}
				</Layout.Content>
				<Layout.Footer style={{ textAlign: "center" }}>
					House of Insurtech©{new Date().getFullYear()}
				</Layout.Footer>
			</Layout>
		);
	}

	handleLogoutButtonClick = () => {
		this.props.context.applicationService.logout();
		this.props.history.push("/");
	};
}

export default DefaultLayout;
